/** Sleeps for the duration specified in milliseconds. */
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/** Handles the loading animation. */
const main = async () => {
	if (localStorage.getItem("visited") !== "t") {
		localStorage.setItem("visited", "t");
		await sleep(3000);
		document.getElementById("loading").classList.add("!opacity-0");
		await sleep(1000);
	}
	document.getElementById("loading").classList.add("hidden");
}

main();
